/* global process */
let base = window._env_.VUE_APP_FIN_CENTER_HOST

// 获取付款详情
export const getpaymentManagerNewDetail = params => {
  return axios.get(`${base}/payment-applications/${params.id}`, { params })
}

// 会计审批（新）
export const accountantReviewPaymentApplicationNew = params => {
  return axios.put(`${base}/payment-applications/${params.id}/finance/accountant/status/v2`, params)
}

// 财务经理审批（新）
export const managerReviewPaymentApplicationNew = params => {
  return axios.put(`${base}/payment-applications/${params.id}/finance/manager/status/v2`, params)
}



// WEBPACK FOOTER //
// ./src/views/payment-approval-new/payment-approval.api.js